import { FC } from "react";
import { Link } from "react-router-dom";
import { Alert } from "../../design-system";
import { UserNotification } from "../../types/NotificationTypes";
import classes from "./NotificationToasts.module.less";

export interface NotificationToastsProps {
    /** Newest first; each is a card until opened or dismissed. */
    toasts: UserNotification[];
    /** The card's body was clicked: it goes to the project. */
    onOpen: (notification: UserNotification) => void;
    onDismiss: (id: number) => void;
}

/**
 * The cards in the top right corner, one per notification that arrived
 * while the app was open (plans/notifications.md, section 5). A card is
 * the design system's warning alert, and stays until the user opens or
 * dismisses it: a card that fades can be missed, which is the whole point.
 */
export const NotificationToasts: FC<NotificationToastsProps> = ({ toasts, onOpen, onDismiss }) => {
    if (toasts.length === 0) return null;
    return (
        <div className={classes.stack}>
            {toasts.map((notification) => (
                <Alert
                    key={notification.id}
                    type="warning"
                    showIcon
                    closable
                    className={classes.toast}
                    message="You have a new notification"
                    description={
                        <Link
                            to={`/project/${notification.data.projectId}`}
                            className={classes.body}
                            onClick={() => onOpen(notification)}
                        >
                            {notification.data.projectName || "Unnamed project"}:{" "}
                            {notification.text}
                        </Link>
                    }
                    onClose={() => onDismiss(notification.id)}
                />
            ))}
        </div>
    );
};
